(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lurivy-v5-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
 const button=event.target.closest('[data-lurivy-unit]');
 if(!button)return;
 const panel=button.closest('details');
 panel.querySelectorAll('[data-lurivy-unit]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 panel.querySelectorAll('[data-cm]').forEach(cell=>{cell.textContent=button.dataset.lurivyUnit==='in'?(Number(cell.dataset.cm)/2.54).toFixed(2)+' in':cell.dataset.cm+' cm';});
});
  } catch(e) { console.error(e); }
})();

})();
